export default __webpack_public_path__ + "static/media/Pilgrim's Cloth of Yag.ec03e424.jpg";